import React, { useState, useEffect } from 'react';
import IconTint from 'react-icon-tint';
import { Link, useHistory } from "react-router-dom";
import { connect, useDispatch, } from 'react-redux';
import * as utility from '../../../../utility/Utility';

import { getOnlineCompetitiveSubscriptionDetailsData, getOnlineCompetitiveQuestionListData } from '../../../../store/actions/OnlineExamAction';


export default function CategorySetCard(props) {

	const history = useHistory();
	const dispatch = useDispatch();

	const [purchsedSet, setPurchsedSet] = useState('');
	const [matPurchsedSet, setMatPurchsedSet] = useState('');

	const onExamTypeHandler = () => {

		if (props.isSubscribe == 1) {
			history.push({
				// pathname: "/e-library-subject",
				pathname: "/e-library-competitive-list",
				state: props.id
			})
		} else if (props.isSubscribe == 0) {
			utility.showError('No elibrary exsits');
		}
	}

	useEffect(() => {
		const setTotalData = [];
		var setText = null;
		for (let i = 0; i < props.satCount.no_set; i++) {
			let setText = {};
			setText['name'] = "ComSet " + (i + 1);
			setText['com_set_no'] = i + 1;
			setTotalData.push(setText);
		}
		setPurchsedSet(setTotalData)

		const setMatTotalData = [];
		var setText = null;
		for (let i = 0; i < props.matCount.no_set; i++) {
			let setText = {};
			setText['name'] = "ComSet " + (i + 1);
			setText['com_set_no'] = i + 1;
			setMatTotalData.push(setText);
		}
		setMatPurchsedSet(setMatTotalData)

	}, [props.satCount, props.matCount]);

	const setlectIndividualSetData = (subscription_id, set_no, subtype) => {
		// console.log("------**---", "NTSE", subscription_id, set_no, subtype,  )
		// dispatch(getOnlineCompetitiveQuestionListData("NTSE", subscription_id, set_no, subtype, history))
		history.push({ pathname: '/page-competitive-exam', state: { exam_type: "NTSE", subscription_id: subscription_id, set_no: set_no, subtype: subtype, } });

		const examDetails = {
			exam_type: "NTSE",
			subscription_id: subscription_id,
			set_no: set_no,
			subtype: subtype,
		}
		localStorage.setItem('examConditionDataCompetitive', JSON.stringify(examDetails));

	}

	return (
		<>
			<div className="row">
				<div className="exam_inside_container" >

					{/* <Link
						onClick={onExamTypeHandler}
					> */}

					<div className="col-md-6 contain_container_top" style={{ backgroundColor: props.bgColor }}>
						<div className="left_container">
							{props.icon != '' && props.icon != null ?
								<IconTint
									src={props.icon}
									alt=""
									color={props.leftColor}
									className={props.iconClass}
								/>
								:
								<div>
									No Image
								</div>
							}
						</div>
						<div className="middle_container">
							<div className="middle_inside_container">
								<h3 className="font_white">{props.title}</h3>
								<p className="font_white">{props.description}</p>
							</div>
						</div>
						<div className="right_container">
							<IconTint
								src={props.icon}
								alt=""
								color="#fff"
								className={props.iconClassRgt} />
						</div>
					</div>
					{/* </Link> */}

					<div className='set_parent_container'>

						{purchsedSet != '' && props.id == 0 ?
							purchsedSet.map((item, index) => {
								return (
									index + 1 == props.satCount.current_exam_set && props.satCount.is_active == 1 ?
										<div className='dflex jcc aic set_container cursorPointer' key={index} style={{ backgroundColor: '#02879B', color: '#fff' }} onClick={() => setlectIndividualSetData(props.satCount.no_set, (index + 1), 1)}>
											Set {index + 1} {props.satCount.interm_count == 0 ? '' : `(${props.satCount.interm_count}/3)`}
										</div>
										: index + 1 < props.satCount.current_exam_set ?
											<div className='dflex jcc aic set_container' key={index} style={{ backgroundColor: '#8389E0', color: '#fff' }} >
												Set {index + 1} <i className="bi bi-check2-circle"></i>
											</div>
											:
											<div className='dflex jcc aic set_container disable_set' key={index} >
												Set {index + 1}
											</div>
								)
							})
							: null}

						{matPurchsedSet != '' && props.id == 1 ?
							matPurchsedSet.map((item, index) => {
								return (
									index + 1 == props.matCount.current_exam_set && props.matCount.is_active == 1 ?
										<div className='dflex jcc aic set_container cursorPointer' key={index} style={{ backgroundColor: '#02879B', color: '#fff' }} onClick={() => setlectIndividualSetData(props.matCount.no_set, (index + 1), 2)}>
											Set {index + 1} {props.matCount.interm_count == 0 ? '' : `(${props.matCount.interm_count}/3)`}
										</div>
										: index + 1 < props.matCount.current_exam_set ?
											<div className='dflex jcc aic set_container' key={index} style={{ backgroundColor: '#8389E0', color: '#fff' }} >
												Set {index + 1} <i className="bi bi-check2-circle"></i>
											</div>
											:
											<div className='dflex jcc aic set_container disable_set' key={index} >
												Set {index + 1}
											</div>
								)
							})
							: null}
					</div>
				</div>
			</div>

		</>
	)
}